import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getUserStatus } from "../../redux/Actions/GetDocsActions";
import { logOut } from "../../redux/Actions/LoginActions";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import Spinner from "react-spinner-material";
import Storage from "../../utils/storage";
import { useHistory } from "react-router-dom";
import UserInfo from "./UserInfo";
import jwt_decode from "jwt-decode";
import { getTestCards } from "../../redux/Actions/PosActions";
import NoDocs from "../../components/Dashboard/NoDocs";
import Rejected from "../../components/Dashboard/Rejected";
import Approved from "../../components/Dashboard/Approved";
import CertInProgress from "../../components/Dashboard/CertInProgress";
import Update from "../../components/Dashboard/Update";
import Pending from "../../components/Dashboard/Pending";
import PosPending from "../../components/Dashboard/PosPending";
import { PropTypes } from "prop-types";
import VerifyStaff from "../../components/Dashboard/Verify";

const Dashboard = ({
  getStatus,
  isGetting,
  dashboardData,
  getStatusSuccess,
  logOut,
  error,
  getTestCards,
  cards,
}) => {




  const history = useHistory();
  let userStatus = Storage.get("user-access-data");

  const user = JSON.parse(userStatus);

  let userType = user && user.type;
  let categoryChoice = user && user.category_id;

  let userToken = Storage.get("user-access-token");

  const token = jwt_decode(userToken);

  let companyId = token && token.id;

  useEffect(
    () => {
      getStatus();
      getTestCards();
    },
    // eslint-disable-next-line
    [getStatus, getTestCards]
  );

  useEffect(
    () => {
      if (error && error.data && error.data.suspension_note) {
        const payload = {
          access_token: userToken,
        };
        logOut(payload);
      }
    },
    [error, userToken, logOut]
    // eslint-disable-next-liner4
  );

  const [state, setState] = useState({
    hideError: true,
  });


  const pos =
    dashboardData && dashboardData[1] && dashboardData[1]?.pos_application;

  const posLength =
    (dashboardData &&
      dashboardData[1] &&
      dashboardData[1].pos_application_length);
  const status =
    dashboardData && dashboardData[0] && dashboardData[0].default_application;
  const defaultApp =
    dashboardData && dashboardData[0] && dashboardData[0].default_application;
  const application_info =
    dashboardData && dashboardData[2] && dashboardData[2].application_info;
  const updatingStatus =
    status && status[0] && status[0].nibss_super_admin_status;
  const updatingStatus2 = status && status[0] && status[0].status;
  const appId = status && status[0] && status[0].id;
  const results = cards;
  const resultsLength = cards && cards[0] && cards[0].card_request;
  const testCardStatus = cards && cards[0] && cards[0].count;
  const certifiedStatus =
    updatingStatus === "pending" || updatingStatus2 === "pending";
  const check1 =
    ((pos && pos.length !== 0) || (pos && pos.length === 0)) &&
    status &&
    status.length !== 0;
  const check2 = pos && pos.length !== 0 && status && status.length === 0;


  // console.log({defaultApp})


  const expired = pos?.[0]?.cbn_license_expired;


  const goToSinglePage = (id, link, name, color) => {
    history.push({
      pathname: "/docs",
      state: {
        id: id,
        link: link,
        name: name,
        color: color,
        posLength: posLength,
      },
    });
  };

  const goToSinglePage2 = () => {
    history.push({
      pathname: "/docs",
      state: {
          posLength: posLength,
      },
    });
  };

  const hideBar = () => {
    setState({
      ...state,
      hideError: false,
    });
  };

  return (
    <div className="container">
      <UserNav />
      <Sidebar />

      <VerifyStaff />

      {isGetting  ? (
        <div className="container-body2">
          <div className="center-spinner">
            <Spinner
              size={120}
              color={"#047558"}
              spinnerwidth={5}
              visible={true}
            />
          </div>
        </div>
      ) :
       dashboardData && dashboardData.length === 0 ? (
        <NoDocs
          defaultApp={defaultApp}
          dashboardData={dashboardData}
          getStatusSuccess={getStatusSuccess}
          isGetting={isGetting}
          status={status}
          userType={userType}
          certifiedStatus={certifiedStatus}
          appId={appId}
          companyId={companyId}
          results={results}
          resultsLength={resultsLength}
          getStatus={getStatus}
          categoryChoice={categoryChoice}
          testCardStatus={testCardStatus}
        />
      ) : (
        <div>
          <main className="container-body2">
            {check1 && (
              <UserInfo
                defaultApp={defaultApp}
                status={status}
                isGetting={isGetting}
                dashboardData={dashboardData}
                getStatusSuccess={getStatusSuccess}
              />
            )}
            {check2 && (
              <UserInfo
                defaultApp={defaultApp}
                status={pos}
                isGetting={isGetting}
                dashboardData={dashboardData}
                getStatusSuccess={getStatusSuccess}
              />
            )}
          </main>
          <div className="container-body3">
            {pos &&
              (pos.length !== 0 || pos.length === 0) &&
              status &&
              status.length !== 0 && (
                <div className="dashboard-main">
                  <Rejected
                    status={status}
                    hideBar={hideBar}
                    hideError={state.hideError}
                    results={results}
                    companyId={companyId}
                    resultsLength={resultsLength}
                    getStatus={getStatus}
                    userType={userType}
                    categoryChoice={categoryChoice}
                    testCardStatus={testCardStatus}
                    application_info={application_info}
                    goToSinglePage={goToSinglePage}
                    expired={expired}
                  />

                  <div className="dashboard-main-content">
                    {status &&
                      status.map((application) => (
                        <div key={application.id}>
                          <Approved
                            status={status}
                            application_info={application_info}
                            userType={userType}
                            goToSinglePage={goToSinglePage}
                            application={application}
                            companyId={companyId}
                            results={results}
                            resultsLength={resultsLength}
                            getStatus={getStatus}
                            categoryChoice={categoryChoice}
                            testCardStatus={testCardStatus}
                            expired={expired}
                          />
                          <Pending
                            status={status}
                            userType={userType}
                            application={application}
                            companyId={companyId}
                            getStatus={getStatus}
                            results={results}
                            resultsLength={resultsLength}
                            categoryChoice={categoryChoice}
                            testCardStatus={testCardStatus}
                            expired={expired}
                          />

                          <Update
                            application={application}
                            application_info={application_info}
                            goToSinglePage={goToSinglePage}
                            status={status}
                            userType={userType}
                            certifiedStatus={certifiedStatus}
                            companyId={companyId}
                            results={results}
                            resultsLength={resultsLength}
                            getStatus={getStatus}
                            categoryChoice={categoryChoice}
                            testCardStatus={testCardStatus}
                            expired={expired}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              )}

            {pos && pos.length !== 0 && status && status.length === 0 && (
              <div className="dashboard-main">
                <Rejected
                  status={pos}
                  pos={pos}
                  hideBar={hideBar}
                  hideError={state.hideError}
                  results={results}
                  companyId={companyId}
                  resultsLength={resultsLength}
                  getStatus={getStatus}
                  userType={userType}
                  categoryChoice={categoryChoice}
                  testCardStatus={testCardStatus}
                  application_info={application_info}
                  goToSinglePage={goToSinglePage}
                  expired={expired}
                />

                <div className="dashboard-main-content">
                  {pos &&
                    pos.map((application) => (
                      <div key={application.id}>
                        <Approved
                          status={pos}
                          pos={pos}
                          application_info={application_info}
                          userType={userType}
                          goToSinglePage={goToSinglePage}
                          application={application}
                          companyId={companyId}
                          results={results}
                          resultsLength={resultsLength}
                          getStatus={getStatus}
                          categoryChoice={categoryChoice}
                          testCardStatus={testCardStatus}
                          expired={expired}
                        />
                        <CertInProgress
                          posLength={posLength}
                          application_info={application_info}
                          application={application}
                          userType={userType}
                          goToSinglePage={goToSinglePage}
                          goToSinglePage2={goToSinglePage2}
                          status={pos}
                          pos={pos}
                          getStatus={getStatus}
                          companyId={companyId}
                          results={results}
                          resultsLength={resultsLength}
                          categoryChoice={categoryChoice}
                          testCardStatus={testCardStatus}
                          expired={expired}
                        />
                        <PosPending
                          status={pos}
                          application_info={application_info}
                          pos={pos}
                          userType={userType}
                          application={application}
                          companyId={companyId}
                          getStatus={getStatus}
                          goToSinglePage={goToSinglePage}
                          results={results}
                          resultsLength={resultsLength}
                          categoryChoice={categoryChoice}
                          testCardStatus={testCardStatus}
                          expired={expired}
                        />
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getStatus: () => dispatch(getUserStatus()),
  getTestCards: () => dispatch(getTestCards()),
  logOut: (payload) => dispatch(logOut(payload)),
});

const mapStateToProps = (state) => {
  return {
    isGetting: state.docs.isGetting,
    dashboardData: state.docs.status,
    getStatusSuccess: state.docs.getStatusSuccess,
    error: state.docs.error,
    cards: state.pos.cards,
  };
};

Dashboard.propTypes = {
  getStatus: PropTypes.func,
  isGetting: PropTypes.bool,
  dashboardData: PropTypes.array,
  getStatusSuccess: PropTypes.bool,
  logOut: PropTypes.func,
  error: PropTypes.object,
  getTestCards: PropTypes.func,
  cards: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);